import React, { Fragment } from "react";
import { Text, View, StyleSheet } from "@react-pdf/renderer";
import moment from "moment";

const styles = StyleSheet.create({
  titleContainer: {
    flexDirection: "row",
    marginTop: 10,
    marginBottom: 5,
    border: 1,
    borderColor: "#000",
    padding:10
  },
  reportTitle: {
    fontSize: 9,
    lineHeight: 1.5,
  },
  reportLeft: {
    width: "100%",
    textAlign: "left",
    marginTop: 5,
  },
  
  reportTitle: {
    fontSize: 9,
    lineHeight: 1.5,
    width: "100%",
    textAlign: "left",
  },
  
  reportTitlehead: {
    fontSize: 12,
    lineHeight: 1.5,
    width: "100%",
    textAlign: "left"
  },
 
  
});

const PlanName = ({ invoice }) => {
  var invoice1 = JSON.stringify(invoice);
  var invoice2 = JSON.parse(invoice1);
  var invoice3 = JSON.parse(invoice2);
  return (
    <Fragment>
      <View style={styles.titleContainer}>
        
        <View style={styles.reportLeft}>
        <Text style={styles.reportTitlehead}>
          <b>Plan Name: {invoice3?.planname.replace('"','')}</b> </Text>
        <Text style={styles.reportTitle}>
        Start date :{moment(invoice3?.startDate).format("D MMM Y")} - End date :{moment(invoice3?.endDate).format("D MMM Y")}.{"\n"}
        ({invoice3?.totalDays}N / {invoice3?.totalDays + 1} Day) -  {invoice3?.itineraryDetails.map((plan, index) => { return(<>{`${plan.name}N ${plan?.Location?.label} `} </>)})}  
        </Text>
        <Text style={styles.reportTitle}>
        {invoice3?.selectedStartLocation !='' &&(<>Start: {invoice3?.selectedStartLocation}</>)}- {invoice3?.selectedEndLocation !='' &&(<>End: {invoice3?.selectedEndLocation}</>)}
        </Text>
        </View>
      </View>
    </Fragment>
  );
};

export default PlanName;
